import type {
  OrgRunControlType,
  OrgRunDatePreset,
  OrgRunStatusGroup,
  OrgRunTestType,
} from '../../types/controlTestRun.ts';

export interface FilterOption<V extends string> {
  value: V;
  label: string;
}

export const DATE_RANGE_OPTIONS: readonly FilterOption<OrgRunDatePreset>[] = [
  { value: 'all', label: 'All Time' },
  { value: '7d', label: 'Last 7 Days' },
  { value: '30d', label: 'Last 30 Days' },
  { value: '90d', label: 'Last 90 Days' },
];

/** Sent as `?status=`; the backend maps each group to workflow_status values (OrgRunStatusGroups). */
export const STATUS_FILTER_OPTIONS: readonly FilterOption<OrgRunStatusGroup>[] = [
  { value: 'all', label: 'All statuses' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'in_review', label: 'In review' },
  { value: 'signed_off', label: 'Signed off' },
  { value: 'failed', label: 'Failed' },
];

export const TEST_TYPE_FILTER_OPTIONS: readonly FilterOption<OrgRunTestType>[] = [
  { value: 'all', label: 'All (TOD / TOE)' },
  { value: 'tod', label: 'Design (TOD)' },
  { value: 'toe', label: 'Operating (TOE)' },
];

export const CONTROL_TYPE_FILTER_OPTIONS: readonly FilterOption<OrgRunControlType>[] = [
  { value: 'all', label: 'All types' },
  { value: 'Manual', label: 'Manual' },
  { value: 'Automated', label: 'Automated' },
];
